<button mat-menu-item [routerLink]="['/profile']" title="{{'APP.TOOLTIPS.MY_PROFILE' | translate}}">
  <mat-icon>account_circle</mat-icon>
  <span>{{ (displayName$ | async) }}</span>
</button>
